<template>
  <div :class="['intersite-nav', { 'intersite-nav--expanded': expanded }]">
    <div class="intersite-nav__wrapper">
      <div @click.stop="toggleExpanded()" class="intersite-nav__tab">
        {{ $beet.options.intersites_nav.tab_label }}
        <img src="@/assets/icons/arrowNav.svg" class="intersite-nav__arrow" alt="Arrow" />
      </div>
      <div @click.stop.self="toggleExpanded()" class="intersite-nav__content">
        <ImageCard
          :content="{
            ...$beet.options.intersites_nav.majoris,
            description: $beet.options.intersites_nav.majoris.content,
          }"
          :button="$beet.options.intersites_nav.visit_website"
        />
        <ImageCard
          :content="{
            ...$beet.options.intersites_nav.dvfo,
            description: $beet.options.intersites_nav.dvfo.content,
          }"
          :button="$beet.options.intersites_nav.visit_website"
        />
      </div>
    </div>
    <div @click.stop="toggleExpanded()" class="intersite-nav__bg-darken"></div>
  </div>
</template>
<script>
import ImageCard from '@/components/cards/ImageCard.vue'

export default {
  name: 'IntersiteNav',
  components: { ImageCard },
  data() {
    return {
      expanded: false,
    }
  },
  methods: {
    toggleExpanded() {
      this.expanded = !this.expanded
      // Scroll to top of the div when not expanded to fix graphical glitch
      if (!this.expanded) {
        this.$el.scrollTo(0, 0)
      }
    },
  },
}
</script>
